import { render } from "./SiteNav.vue?vue&type=template&id=6523e1b4&scoped=true"
import script from "./SiteNav.vue?vue&type=script&lang=js"
export * from "./SiteNav.vue?vue&type=script&lang=js"

import "./SiteNav.vue?vue&type=style&index=0&id=6523e1b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6523e1b4"]])

export default __exports__